module.exports = __webpack_public_path__ + "img/personnage_choix_5.b358850e.png";